import angular from 'angular'
import { smartgoods } from 'redevConfig'

const list = (smartgoods && smartgoods.list) || ''
const edit = (smartgoods && smartgoods.edit) || ''

const listPage = list ? require(`redevelopment/outputManage/smartGoods/${list.templateName}`) : require('./view/list.html')
const SmartGoodsListCtrl = list ? require(`redevelopment/outputManage/smartGoods/${list.controllerName}`) : require('./SmartGoodsListCtrl')
const SmartGoodsEditCtrl = edit ? require(`redevelopment/outputManage/smartGoods/${edit.controllerName}`) : require('./SmartGoodsEditCtrl')

function config($stateProvider) {
    $stateProvider.state('outputManage.ovat.smartgoods', {
        url: '/smartgoods',
        abstract: true,
        template: '<div ui-view></div>',
        title: '智能赋码',
        default: 'outputManage.ovat.smartgoods.list',
    }).state('outputManage.ovat.smartgoods.list', {
        url: '/list',
        controller: 'smartGoodsListCtrl',
        template: listPage,
        default: 'outputManage.ovat.smartgoods.list',
    })
}

export default angular
    .module('outputManage.ovat.smartgoods', [])
    .config(['$stateProvider', config])
    .controller('smartGoodsListCtrl', SmartGoodsListCtrl.default)
    .controller('smartGoodsEditCtrl', SmartGoodsEditCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/smartGoods/index.js